(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[421],{

/***/ 40313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ bibliography; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/next/components/Head/Head.js + 4 modules
var Head = __webpack_require__(36037);
// EXTERNAL MODULE: ./src/next/components/MainLayout/MainLayout.js + 7 modules
var MainLayout = __webpack_require__(19162);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/utils/array.js
var array = __webpack_require__(21707);
// EXTERNAL MODULE: ./src/next/components/SortIcons/sortIcons.module.scss
var sortIcons_module = __webpack_require__(56584);
var sortIcons_module_default = /*#__PURE__*/__webpack_require__.n(sortIcons_module);
;// CONCATENATED MODULE: ./src/next/components/SortIcons/SortIcons.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var icons = [{
  icon: EgwWebFont/* default.chevron-up */.Z["chevron-up"],
  direction: array/* SortDirection.ASC */.Sr.ASC
}, {
  icon: EgwWebFont/* default.chevron-down */.Z["chevron-down"],
  direction: array/* SortDirection.DESC */.Sr.DESC
}];

var SortIcons = function SortIcons(_ref) {
  var highlightCurrent = _ref.highlightCurrent,
      sortDirection = _ref.sortDirection;
  return /*#__PURE__*/react.createElement("div", {
    className: (sortIcons_module_default())["sort-icons-container"]
  }, icons.map(function (item) {
    var icon = item.icon,
        direction = item.direction;
    var isActive = direction === sortDirection && highlightCurrent;
    return /*#__PURE__*/react.createElement("div", {
      className: (sortIcons_module_default())["sort-icons"],
      key: direction
    }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: icon,
      className: classnames_default()((sortIcons_module_default())["sort-icon"], _defineProperty({}, (sortIcons_module_default())["is-active"], isActive))
    }));
  }));
};

SortIcons.propTypes = {
  highlightCurrent: (prop_types_default()).bool,
  sortDirection: (prop_types_default()).string,
  toggleSort: (prop_types_default()).func
};
/* harmony default export */ var SortIcons_SortIcons = (SortIcons);
// EXTERNAL MODULE: ../shared/components/Tabs/TabBar.js + 1 modules
var TabBar = __webpack_require__(78329);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.constants.js
var routes_constants = __webpack_require__(46072);
// EXTERNAL MODULE: ../shared/utils/select.js
var utils_select = __webpack_require__(48018);
;// CONCATENATED MODULE: ./src/next/components/Abbreviations/Abbreviations.constants.js


var Tab = {
  EGW: "egw",
  BIBLE: "bible"
};
var IdsTabs = Object.values(Tab);
var Tabs = [(0,utils_select/* makeOption */.D)(Tab.EGW, "egw", {
  url: routes_constants/* NEXT_URLS.bibliographyEgw */.h.bibliographyEgw
}), (0,utils_select/* makeOption */.D)(Tab.BIBLE, "bible", {
  url: routes_constants/* NEXT_URLS.bibliographyBible */.h.bibliographyBible
})];
var TabColumns = [{
  className: "abbreviation-code",
  filedName: "abbreviations",
  title: "abbreviation"
}, {
  className: "abbreviation-book-name",
  filedName: "title",
  title: "bookOrPeriodicalTitle"
}, {
  className: "abbreviation-publication",
  filedName: "pub_year",
  title: "publication"
}];
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ./src/next/components/Abbreviations/abbreviations.module.scss
var abbreviations_module = __webpack_require__(34220);
var abbreviations_module_default = /*#__PURE__*/__webpack_require__.n(abbreviations_module);
;// CONCATENATED MODULE: ./src/next/components/Abbreviations/Abbreviations.js
function Abbreviations_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















var Abbreviations = function Abbreviations(_ref) {
  var abbreviations = _ref.abbreviations;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activeField = _useState4[0],
      setActiveField = _useState4[1];

  var _useMemo = (0,react.useMemo)(function () {
    var typeQuery = router.query.type;
    var type = IdsTabs.includes(typeQuery) ? typeQuery : Tab.EGW;
    var list = abbreviations[type] || [];
    return {
      list: sortDirection ? (0,array/* sortByField */.L1)(list, activeField, sortDirection) : list,
      type: type
    };
  }, [abbreviations, activeField, sortDirection, router.query.type]),
      list = _useMemo.list,
      type = _useMemo.type;

  var rendererList = list.map(function (item) {
    return /*#__PURE__*/react.createElement("div", {
      key: item.link,
      className: (abbreviations_module_default())["abbreviation-table-row"]
    }, /*#__PURE__*/react.createElement("span", {
      className: (abbreviations_module_default())["abbreviation-code"]
    }, item.abbreviations.join(", ")), /*#__PURE__*/react.createElement("span", {
      className: (abbreviations_module_default())["abbreviation-book-name"]
    }, /*#__PURE__*/react.createElement((link_default()), {
      href: url/* URLS.book */.ns.book + "/" + (0,content/* getBookIdWithPrefix */.NR)(item.link),
      passHref: true
    }, item.title)), /*#__PURE__*/react.createElement("span", {
      className: (abbreviations_module_default())["abbreviation-publication"]
    }, item.pub_year));
  });

  var handleChangeTab = function handleChangeTab(key) {
    var tab = Tabs.find(function (o) {
      return (0,utils_select/* getOptionKey */._)(o) === key;
    });
    router.replace(tab.url);
    setActiveField(null);
    setSortDirection(null);
  };

  var handleClickColumnHeader = function handleClickColumnHeader(filedName) {
    setActiveField(filedName);

    if (sortDirection === array/* SortDirection.ASC */.Sr.ASC) {
      setSortDirection(array/* SortDirection.DESC */.Sr.DESC);
    } else if (sortDirection === array/* SortDirection.DESC */.Sr.DESC) {
      setSortDirection(null);
    } else {
      setSortDirection(array/* SortDirection.ASC */.Sr.ASC);
    }
  };

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((abbreviations_module_default())["abbreviation-wrap"], Abbreviations_defineProperty({}, (abbreviations_module_default())[type], type))
  }, /*#__PURE__*/react.createElement(TabBar/* default */.Z, {
    activeTabClassName: (abbreviations_module_default()).active,
    alignLeft: true,
    options: Tabs,
    current: type,
    onSelectTab: handleChangeTab
  }), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((abbreviations_module_default())["abbreviation-table-header"], (abbreviations_module_default())["abbreviation-table-row"])
  }, TabColumns.map(function (_ref2) {
    var className = _ref2.className,
        title = _ref2.title,
        filedName = _ref2.filedName;
    return /*#__PURE__*/react.createElement("div", {
      key: title,
      onClick: function onClick() {
        return handleClickColumnHeader(filedName);
      },
      className: classnames_default()((abbreviations_module_default())["abbreviation-row-item"], (abbreviations_module_default())[className])
    }, /*#__PURE__*/react.createElement("div", {
      className: (abbreviations_module_default())["table-column-item__body"]
    }, /*#__PURE__*/react.createElement("span", null, t(title)), /*#__PURE__*/react.createElement(SortIcons_SortIcons, {
      highlightCurrent: activeField === filedName,
      sortDirection: sortDirection
    })));
  })), /*#__PURE__*/react.createElement("div", {
    className: (abbreviations_module_default())["abbreviation-content"]
  }, rendererList));
};

Abbreviations.propTypes = {
  abbreviations: (prop_types_default()).object
};
/* harmony default export */ var Abbreviations_Abbreviations = (Abbreviations);
// EXTERNAL MODULE: ../shared/api/content/books/requests.js
var requests = __webpack_require__(92834);
;// CONCATENATED MODULE: ./src/pages/bibliography.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function bibliography_slicedToArray(arr, i) { return bibliography_arrayWithHoles(arr) || bibliography_iterableToArrayLimit(arr, i) || bibliography_unsupportedIterableToArray(arr, i) || bibliography_nonIterableRest(); }

function bibliography_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function bibliography_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return bibliography_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bibliography_arrayLikeToArray(o, minLen); }

function bibliography_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function bibliography_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function bibliography_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }







var AbbreviationsPage = function AbbreviationsPage(_ref) {
  var breadcrumbsProps = _ref.breadcrumbsProps,
      pageUrl = _ref.pageUrl;

  var _useState = (0,react.useState)({}),
      _useState2 = bibliography_slicedToArray(_useState, 2),
      abbreviations = _useState2[0],
      setAbbreviations = _useState2[1];

  (0,react.useEffect)(function () {
    function fetchAbbreviations() {
      return _fetchAbbreviations.apply(this, arguments);
    }

    function _fetchAbbreviations() {
      _fetchAbbreviations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var fetchedAbbreviations;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,requests/* getAbbreviationsRequest */.zm)();

            case 2:
              fetchedAbbreviations = _context.sent;
              setAbbreviations(fetchedAbbreviations);

            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchAbbreviations.apply(this, arguments);
    }

    fetchAbbreviations();
  }, []);
  return /*#__PURE__*/react.createElement(MainLayout/* default */.Z, {
    breadcrumbs: breadcrumbsProps
  }, /*#__PURE__*/react.createElement(Head/* default */.Z, {
    pageTitle: breadcrumbsProps.title,
    url: pageUrl
  }), /*#__PURE__*/react.createElement(Abbreviations_Abbreviations, {
    abbreviations: abbreviations
  }));
};

var __N_SSP = true;
/* harmony default export */ var bibliography = (AbbreviationsPage);

/***/ }),

/***/ 7525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bibliography",
      function () {
        return __webpack_require__(40313);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","abbreviation-wrap":"abbreviations_abbreviation-wrap__DxHs1","bible":"abbreviations_bible__XzmPZ","abbreviation-row-item":"abbreviations_abbreviation-row-item__2l00v","egw":"abbreviations_egw__Dmu19","char-wrap":"abbreviations_char-wrap__05l_g","abbreviation-content":"abbreviations_abbreviation-content__YCcy0","abbreviation-table-row":"abbreviations_abbreviation-table-row__dXoAF","table-column-item__body":"abbreviations_table-column-item__body__syl_0","abbreviation-code":"abbreviations_abbreviation-code__V9oh0","abbreviation-book-name":"abbreviations_abbreviation-book-name__DPZtZ","abbreviation-publication":"abbreviations_abbreviation-publication___wngS","abbreviation-table-header":"abbreviations_abbreviation-table-header__NAKkw"};

/***/ }),

/***/ 56584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sort-icons-container":"sortIcons_sort-icons-container__PAPMY","sort-icons":"sortIcons_sort-icons__HUxTW","sort-icon":"sortIcons_sort-icon__zqqha","is-active":"sortIcons_is-active__n_vxr"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [218,239,888,774,179], function() { return __webpack_exec__(7525); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);